export const LOCAL_STORAGE_NAME = 'recordList';
export const ARIA_BUSY_DELAY_MS = 3000;
export const LITRES_PER_GALLON = 4.54609;
